import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useCallback, useContext, useMemo } from 'react';
import ModalContext from '~/context/home/ModalContext';
import { NativeModalId } from '~/context/home/ModalContext/constants';
import { logError } from '~/utilities/loggers';
import { ListenerEvent, ListenerEventType } from './constants';

type CloseModalPayload = { modal: NativeModalId };

function isCloseModalMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, CloseModalPayload> {
  return (
    message.event === ListenerEvent.CloseModal && message.payload.modal != null
  );
}

function useHandleCloseModal(): (modal: NativeModalId) => void {
  const { setSoftPullModalOpen } = useContext(ModalContext);

  return useCallback(
    (modal: NativeModalId) => {
      switch (modal) {
        case NativeModalId.SoftPull:
          setSoftPullModalOpen(false);
          break;
        default:
          logError(new Error('Unknown modal'), { modal });
      }
    },
    [setSoftPullModalOpen]
  );
}

export default function (): MessageHandler<
  ListenerEventType,
  CloseModalPayload
> {
  const handleCloseModal = useHandleCloseModal();

  return useMemo(
    () =>
      new MessageHandler(isCloseModalMessage, message => {
        handleCloseModal(message.payload.modal);
      }),
    [handleCloseModal]
  );
}
